<!-- 作业反馈 -->
<template>
  <div>
    <div class="index">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>

      <div>
        <!-- <div class="Homeboxtop_nav_tab">
          <span
            v-for="(item, index) in tabList"
            :class="['res-tab', { active: item.name === tabName }]"
            :key="index"
            @click="tabClick(item)"
          >
            {{ item.name }}
          </span>
        </div> -->
        <el-form :inline="true" :model="queryParams" label-width="45px">
          <el-form-item label="学期:">
            <el-select
              v-model="queryParams.semester"
              placeholder="请选择"
              class="label"
              style="width: 220px"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="parts" style="margin-top: 20px">
          <div class="parts-top d-flex">
            <div style="width: 50%" class="parts-top-item">
              <div class="header-item-title">
                <span class="circle"></span>
                <span>班级作业平均完成时长</span>
              </div>
              <!-- <div class="Homeboxtop_nav_tab">
                <span
                  v-for="(item, index) in tabList"
                  :class="['res-tab', { active: item.name === tabName }]"
                  :key="index"
                  @click="tabClick(item)"
                >
                  {{ item.name }}
                </span>
              </div> -->
            </div>
            <div style="width: 50%" class="parts-top-item">
              <div class="header-item-title">
                <span class="circle"></span>
                <span>学校作业平均完成时长分布</span>
              </div>
            </div>
          </div>
          <div class="parts-bottom">
            <div id="charts_box1" class="bottom-item"></div>
            <div id="charts_box2" class="bottom-item"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getHwFeedbackList } from "@/api/school/index.js";
import dayjs from "dayjs";
// import to from "@/utils/await-to";
// import reqTip from "@/utils/requestTip";
import localForage from "localforage";
import * as echarts from "echarts";

export default {
  components: {},
  data() {
    return {
      tableData: [],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      semesterList: [],
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
      },
      tabList: [
        { name: "本周" },
        { name: "本月" },
        { name: "本学期" },
        { name: "本年度" },
      ],
      tabName: "本周",
    };
  },
  watch: {},
  activated() {
    this.getTableData();
  },
  created() {
    this.init();
    if (this.semesterArr && this.semesterArr.length > 0) {
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
        isCurrent: v.isCurrent,
        startDate: v.startDate,
        endDate: v.endDate,
      }));
      let semesterRes = this.semesterList.filter((e) => e.isCurrent);
      this.queryParams.semester = semesterRes[0]?.value;
    }
  },
  methods: {
    tabClick(item) {
      this.tabName = item.name;
    },
    init() {
      let vm = this;
      this.$nextTick(() => {
        let chartDom1 = document.getElementById("charts_box1");
        let myChart = echarts.init(chartDom1);
        let option = {
          tooltip: {
            trigger: "item",
            backgroundColor: "rgba(0, 0, 0, .6)", //通过设置rgba调节背景颜色与透明度
            borderWidth: "0",
            textStyle: {
              color: "white",
              fontSize: "12",
            },
            formatter: function (params, ticket, callback) {
              return (
                "<span style='font-size: 26px;line-height: 30px;'>" +
                params.value +
                "</span>" +
                "<br />" +
                "<span style='font-size:14px;line-height: 18px;'>" +
                params.name +
                "</span>"
              );
            },
          },
          //   legend: {
          //         data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
          //     },
          legend: {
            data: [
              "三年级1班",
              "三年级2班",
              "三年级3班",
              "三年级4班",
              "三年级5班",
            ],
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: "category",
            data: [
              "三年级1班",
              "三年级2班",
              "三年级3班",
              "三年级4班",
              "三年级5班",
            ],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: [82, 100, 80, 95.87, 99.23],
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: "#5BB0FF" },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart.setOption(option);

        // 柱状图
        let chartDom2 = document.getElementById("charts_box2");
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: [
              "10",
              "20",
              "30",
              "40",
              "50",
              "60",
              "70",
              "80",
              "90",
              "100",
              "110",
              "120",
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              data: [16, 11, 22, 19, 27, 10, 27, 10],
            },
          ],
          color: ["#5BB0FF", "#51D6A6"],
        };
        myChart2.setOption(option2);
      });
    },
    // 获取作业反馈列表
    async getTableData() {
      // let ss = sessionStorage;
      // let params = {
      // 	loginPlatformCode: ss.loginPlatformCode,
      // 	platformCode: ss.platformCode,
      // 	usessionid: ss.usessionid,
      // 	pageNum: this.pageNum,
      // 	pageSize: this.pageSize,
      // 	classId: this.queryParams.classId,
      // };
      // const res = await getHwFeedbackList(params);
      // console.log("作业反馈列表--", res);
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 68px;
    line-height: 80px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: 500;
      font-size: 20px;
      text-align: left;
      color: #333;
    }
  }
  .show-hover {
    cursor: pointer;
  }
  .header-item-title {
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    .circle {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #4991e1;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  .parts {
    width: 100%;
    .parts-top {
      .parts-top-item {
        display: flex;
      }
    }
    .parts-bottom {
      width: 100%;
      height: 300px;
      display: flex;
      .bottom-item {
        width: 50%;
        height: 100%;
      }
      .right-tu {
        width: 50%;
        height: 100%;
        overflow: auto;
        #histogram02 {
          width: 1200px;
          height: 100%;
        }
      }
    }
    #charts_box1,
    #charts_box2 {
      width: 370px;
      margin: auto;
    }
    .course-box {
      width: 346px;
      height: 70px;
      border-radius: 4px;
      background: linear-gradient(180deg, #fff 0%, #fff 100%);
      border: 1px solid #eee;
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-size: 18px;
        color: #666;
        margin-left: 20px;
      }
    }
  }
}
</style>
